import React, { useMemo } from 'react';
import { PieChart, Pie, Cell } from 'recharts';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { IPieChartData } from '../../types';

interface IProps {
  data: IPieChartData[];
  size?: number;
  total?: {
    label?: string;
    value: number | string;
  };
}

export const BasePieChart: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { data, size = 200, total } = props;
  const { label = t('labels.total'), value } = total ?? {};

  const hasValue =
    (value !== null &&
      value !== undefined &&
      typeof value === 'number' &&
      value >= 0) ||
    typeof value === 'string';

  const { width, height, cx, cy, innerRadius, outerRadius } = useMemo(() => {
    const w = size;
    const h = size;

    return {
      width: w,
      height: h,
      cx: w / 2.1,
      cy: h / 2.1,
      innerRadius: Math.min(w, h) * 0.3,
      outerRadius: Math.min(w, h) * 0.49,
    };
  }, [size]);

  return (
    <div
      className={s.wrapper}
      style={{ width: `${height}px`, height: `${height}px` }}
    >
      <PieChart width={width} height={height} className={s.chart}>
        <Pie
          data={data}
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
      </PieChart>
      {hasValue && (
        <div className={s.total}>
          {label}
          <span>{value}</span>
        </div>
      )}
    </div>
  );
};
